export default __webpack_public_path__ + "static/media/thumbnail.6e713372.png";